/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { EquisControlMessageStatus } from '@tn-equis/core/components/control-message';
import { EquisTextfieldTypes } from '@tn-equis/core/components/textfield';

import { ButtonDownloadAppService } from '../button-download-app.service';
import { WhatsappService } from '../whatsapp.service';
import { Subject, takeUntil } from 'rxjs';

const DEFAULT_PHONE_PLACEHOLDER = 'Escribilo sin el 0 ni el 15';

@Component({
  selector: 'nx-modal-download-app',
  templateUrl: './modal-download-app.component.html',
  styleUrls: ['./modal-download-app.component.scss'],
})
export class ModalDownloadAppComponent implements OnDestroy {
  // PROPERTIES
  readonly INPUT_TYPE = EquisTextfieldTypes.TEL;
  readonly PHONE_LENGTH = 10;
  isLoading = false;

  // FormControl
  phoneFormControl = new FormControl(
    '',
    Validators.compose([
      Validators.minLength(this.PHONE_LENGTH),
      Validators.pattern('^[0-9]*$'),
    ]),
  );

  phoneInputData = {
    text: DEFAULT_PHONE_PLACEHOLDER,
    status: EquisControlMessageStatus.DEFAULT,
    hasIcon: false,
  };

  get data() {
    return this.dialogService.dialogData;
  }

  private phoneFormErrorTexts = new Map([
    ['minlength', `Deben ser al menos ${this.PHONE_LENGTH} digitos.`],
    ['pattern', 'Deben ser solo números.'],
  ]);
  private destroyed$ = new Subject<void>();

  constructor(
    private whatsappService: WhatsappService,
    private dialogService: ButtonDownloadAppService,
  ) {
    this.phoneFormControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.phoneFormControl.invalid) {
          const error = Object.keys(this.phoneFormControl?.errors!)[0];
          this.phoneInputData.text = this.phoneFormErrorTexts.get(error)!;
          this.phoneInputData.status = EquisControlMessageStatus.ERROR;
        } else {
          this.phoneInputData.text =
            this.phoneFormControl.value?.length === this.PHONE_LENGTH
              ? ''
              : DEFAULT_PHONE_PLACEHOLDER;
          this.phoneInputData.status = EquisControlMessageStatus.DEFAULT;
        }
        this.phoneInputData.hasIcon = this.phoneFormControl.invalid;
      });
  }

  // METHODS
  /**
   * Sends the download link to the user's Whatsapp number
   */
  public sendWhatsapp() {
    this.isLoading = true;

    this.whatsappService.eventHandler
      .pipe(takeUntil(this.destroyed$))
      .subscribe(status => {
        if (
          status === 'success' ||
          status === 'error' ||
          status === 'retryCancel'
        ) {
          this.isLoading = false;
        }
      });

    if (this.phoneFormControl.value) {
      this.whatsappService.sendAppLink(this.phoneFormControl.value);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
